import React from 'react';
import { Check, ArrowRight } from 'lucide-react';

// Reusable split section (image + copy). theme: 'light' | 'mint' | 'dark'.
const SplitSection = ({ eyebrow, title, titleAccent, paragraph, bullets = [], ctaLabel, onCta, image, reverse = false, theme = 'light' }) => {
  const dark = theme === 'dark';
  const bg = theme === 'mint' ? 'bg-[#e8f5ee]' : dark ? 'bg-[#0b1510]' : 'bg-white';
  const heading = dark ? 'text-white' : 'text-[#0f1712]';
  const body = dark ? 'text-white/60' : 'text-[#0f1712]/60';

  return (
    <section className={`${bg} py-24 px-6`}>
      <div className={`max-w-6xl mx-auto grid lg:grid-cols-2 gap-14 items-center ${reverse ? 'lg:[&>*:first-child]:order-2' : ''}`}>
        <div>
          {eyebrow && <p className="text-sm font-semibold text-[#0e9f6e] mb-4">{eyebrow}</p>}
          <h2 className={`font-display text-4xl sm:text-5xl font-700 ${heading}`}>
            {title} {titleAccent && <span className="text-[#0e9f6e]">{titleAccent}</span>}
          </h2>
          {paragraph && <p className={`text-lg mt-6 max-w-md leading-relaxed ${body}`}>{paragraph}</p>}
          {bullets.length > 0 && (
            <ul className="mt-7 space-y-3">
              {bullets.map((b) => (
                <li key={b} className={`flex items-center gap-3 text-[15px] ${dark ? 'text-white/80' : 'text-[#0f1712]/75'}`}>
                  <span className="w-6 h-6 rounded-full bg-[#0e9f6e]/15 flex items-center justify-center shrink-0">
                    <Check size={14} className="text-[#0e9f6e]" />
                  </span>
                  {b}
                </li>
              ))}
            </ul>
          )}
          {ctaLabel && (
            <button onClick={onCta} className="mt-9 inline-flex items-center gap-2 bg-[#0e9f6e] text-white rounded-xl px-7 py-4 text-sm font-semibold hover:bg-[#0c8a60] hover:scale-[1.02] active:scale-95 transition-all">
              {ctaLabel} <ArrowRight size={16} />
            </button>
          )}
        </div>
        <div className="overflow-hidden rounded-[2rem] shadow-[0_25px_70px_rgba(15,23,18,0.15)] aspect-[4/3]">
          <img src={image} alt={title} loading="lazy" className="w-full h-full object-cover" />
        </div>
      </div>
    </section>
  );
};

export default SplitSection;
